import { Divider, Layout, Space, Typography } from 'antd'
import React, { useContext, useMemo } from 'react'
import { StoreContext } from '../../../context/storeContext'
import styles from './footer.module.scss'

const { Footer: AntFooter } = Layout
const { Text } = Typography

const Footer = ({ ...rest }) => {
  const storeContext = useContext(StoreContext)

  // Get the store name directly from StoreContext (which now reads from localStorage and maps properly)
  const displayStoreName = useMemo(() => {
    // StoreContext now handles both Cognito and AD users properly
    // It reads from localStorage and maps store IDs to names using the store mapping file
    return storeContext?.name || ''
  }, [storeContext?.name])

  // Get environment indicator (DEV or PROD)
  const environment = process.env.REACT_APP_ENV?.toUpperCase() === 'PROD' ? 'PROD' : 'DEV'

  return (
    <AntFooter className={styles.footer} {...rest}>
      <div className={styles.footerContent}>
        <Text type="secondary">
          Copyright ©{new Date().getFullYear()} Kolumbus Inc.
        </Text>
        {displayStoreName && (
          <Space split={<Divider type="vertical" className={styles.divider} />}>
            <Text type="secondary" strong className={styles.storeName}>
              {displayStoreName}
              {environment === 'DEV' && (
                <>
                  <Divider type="vertical" className={styles.divider} style={{ margin: '0 6px' }} />
                  {environment}
                </>
              )}
            </Text>
          </Space>
        )}
      </div>
    </AntFooter>
  )
}

export default Footer